
export const initFilterData = {
  JobOrdId: null,
  ScId: null,
  JobNo: null,
  Bkg: null,
  AptTmSt: null,
  AptTmEn: null,
  IsNoScInvId: 1, 
  IsOnlyScJobOrder: 1,
  Loc: null
}

export const initSearchFilterData = {
  JobOrdId: null,
  JobOrdIds: null,
  ContNos: null,
  ScId: null,
  JobNo: null,
  Bkg: null,
  AptTmSt: null,
  AptTmEn: null,
  IsNoScInvId: 1, 
  IsOnlyScJobOrder: 1,
  Loc: null
}

export const initInvFilterData = {
  ScId: null,
  ContNo: null,
  JobNo: null,
  Bkg: null,
  ScInvNo: null,
  XpssDocNum: null,
  AptTmSt: null,
  AptTmEn: null,
  ScInvDteSt: null,
  ScInvDteEn: null,
}

export const initScInvData = {
  ScInvId: null,
  ScInvNo: "",
  XpssDocNum: "",
  ScInvDte: null,
  ScId: null,
  Rmk: "",
  OwnRcptAmnt: 0,
  CusRcptAmnt: 0,
  WhtPr: 0,
  Total: 0,
  PayAmnt: 0,
  IsXpss: 0, 
  XpssDocDte: null,
  DueDte: null,
  CrDay: null
}

export const initScPVData = {
  PVId: null,
  PVNo: "",
  PVDte: null,
  PayMthdId: null,
  BkAccId: null,
  BBNo: "",
  BBPage: null,
  BBRow: null, 
  PayAmnt: 0,
  PayDte: null,
  FeeAmnt: 0,
  DiffDscp: "",
  Rmk: "",
  PrId: null,
  IsCmpt: 0,
  ChqDte: null,
  ChqNo: null,
  ChqBkId: null,
  ChqBrch: null,
  ChqAmnt: 0,
  TrnBkId: null,
  TrnBkBrch: null,
  TrnBkAccNo: null,
  TrnAccNm: null
}